import { types as t, Instance } from 'mobx-state-tree';
import NodeWidget from '~/mst/models/widget/node_widget';
import ChartWidget from '~/mst/models/widget/chart_widget';
import HeatmapWidget from '~/mst/models/widget/heatmap_widget';
import MapWidget from '~/mst/models/widget/map_widget';
import WindRoseWidget from '~/mst/models/widget/wind_rose_widget';
import ConnectivityWidget from '~/mst/models/widget/connectivity_widget';
import DistributionWidget from '~/mst/models/widget/distribution_widget';
import BaseWidget from '~/mst/models/widget';
import Syncable from '~/mst/models/abstract/syncable';
import CollectionMap from '~/mst/models/abstract/collection_map';

const WidgetsModel = t.compose(
  CollectionMap(
    t.union(
      {
        dispatcher(snapshot) {
          const { type } = snapshot;
          switch (type) {
            case 'NodeWidget':
              return NodeWidget;
            case 'HeatmapWidget':
              return HeatmapWidget;
            case 'MapWidget':
              return MapWidget;
            case 'ChartWidget':
              return ChartWidget;
            case 'WindRoseWidget':
              return WindRoseWidget;
            case 'ConnectivityWidget':
              return ConnectivityWidget;
            case 'DistributionWidget':
              return DistributionWidget;
            default:
              return BaseWidget;
          }
        }
      },
      ChartWidget,
      HeatmapWidget,
      ChartWidget,
      NodeWidget,
      MapWidget,
      WindRoseWidget,
      ConnectivityWidget,
      DistributionWidget
    )
  ),
  Syncable
);

export interface IWidgetsModel extends Instance<typeof WidgetsModel> {}

export default WidgetsModel;
